import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-500dd081"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
const _hoisted_8 = {
  class: "dialog-foter"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
import { reactive, ref, onMounted, unref, computed } from "vue";
import { myTodoListPage, addAudit, updateAudit, updateState } from "@/api/deviceManage";
import { ElMessageBox, ElMessage } from 'element-plus';
import { useStore } from "vuex";
import { TRUE } from "sass";
const __default__ = {
  name: "applyList"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const form = ref(null);
    const store = useStore();
    const curUserId = store.state.common.userInfo.userId; //当前用户id

    // 表格标题
    const tableTitle = computed(() => {
      return '我的待办';
    });
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "开阀"
    }, {
      dictValue: 0,
      dictLabel: "关阀"
    }]);
    const statusOptions1 = ref([{
      dictValue: 1,
      dictLabel: "MQTT"
    }, {
      dictValue: 2,
      dictLabel: "AEP"
    }]);
    const state = reactive({
      applyForm: {
        auditComment: ''
      },
      applyRules: {
        auditComment: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      },
      tableData: {
        rows: [],
        total: 0
      },
      open: false,
      dialogVisible: false,
      curId: null,
      // 表单参数
      form: {
        id: null,
        actNum: '',
        opStartTime: '',
        opEndTime: '',
        originDate: "",
        actType: 1,
        applyReason: '',
        valuePos: null,
        valueOpenPos: null
      },
      rules: {
        actNum: [{
          required: true,
          message: "请输入设备编号",
          trigger: "blur"
        }],
        actType: [{
          required: true,
          message: '请选择协议类型',
          trigger: 'blur'
        }],
        valuePos: [{
          required: true,
          message: "请选择执行操作",
          trigger: "blur"
        }],
        valueOpenPos: [{
          required: true,
          message: "请输入控制角度",
          trigger: "blur"
        }],
        originDate: [{
          required: true,
          message: '请选择执行时间',
          trigger: 'blur'
        }],
        applyReason: [{
          required: true,
          message: '请输入申请事由',
          trigger: 'blur'
        }]
      },
      saveLoading: false,
      formData: [{
        prop: "actNum",
        label: "设备编号",
        type: "bigData_list_multi",
        placeholder: "请选择设备编号",
        multiple: false,
        span: 24,
        method: "post",
        dataType: 'data',
        optionsUrl: "/ty-iot-manage/api/v1/actuator/list",
        props: {
          label: 'actNum',
          value: 'actNum'
        },
        queryParams: {
          pageSize: 1000,
          pageNum: 1
        },
        disabledHandle: () => {
          return state.form.id ? true : false;
        },
        change: (val, item) => {
          item.forEach(item => {
            if (item.actNum == val) {
              state.form.actType = item.actType;
            }
          });
        }
      }, {
        prop: "actType",
        label: "协议类型",
        placeholder: "请选择设备编号",
        type: "list",
        isSelect: false,
        options: statusOptions1,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        disabledHandle: () => {
          return true;
        },
        span: 24
      }, {
        prop: "originDate",
        label: "执行时间",
        placeholder: "请选择执行时间",
        type: "datetimerange",
        multiple: true,
        span: 24,
        change: val => {
          if (val?.length) {
            state.form.opStartTime = val[0];
            state.form.opEndTime = val[1];
          } else {
            state.form.opStartTime = '';
            state.form.opEndTime = '';
          }
        }
      }, {
        prop: "valuePos",
        label: "执行操作",
        placeholder: "请选择执行操作",
        type: "radio",
        isSelect: false,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        // hideHandle:()=> {
        //   return state.form.actType==2?true:false;
        // },
        span: 24
      }, {
        prop: "valueOpenPos",
        label: "控制角度",
        placeholder: "请输入角度",
        type: "textNum",
        isSelect: false,
        hideHandle: () => {
          return state.form.actType == 1 ? true : false;
        },
        min: 0,
        max: 100,
        span: 24
      }, {
        prop: "applyReason",
        label: "申请事由",
        placeholder: "请输入申请事由",
        type: "textarea",
        isSelect: false,
        span: 24
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: [],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }]
    });
    // 有执行权限不展示新增按钮
    if (store.state.common.userInfo.actOp == 1) {
      state.buttonsList = [];
    }
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      actNum: "",
      areaId: "",
      valveName: "",
      wellNum: ""
    });
    const searchFormData = ref([{
      prop: "actNum",
      label: "执行器编号",
      placeholder: "请输入执行器编号",
      type: "text",
      span: 4
    }]);
    let loading = ref(false);
    const getList = () => {
      loading.value = true;
      myTodoListPage(queryParams).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const resetQuery = () => {
      queryParams.pageNum = 1;
      queryParams.pageSize = 10;
      queryParams.actNum = "";
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      icon: "el-icon-search",
      class: "btn-liquid",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const formatCode = function (code, column) {
      if (code == 1) {
        return '驳回';
      } else if (code == 2) {
        return '同意';
      } else if (code == 3) {
        return '撤销';
      } else {
        return '待审核';
      }
    };
    const tableHeader = [{
      prop: "actNum",
      label: "设备编号",
      fixed: false,
      type: "text"
    }, {
      prop: "location",
      label: "设备位置",
      fixed: false,
      type: "text"
    }, {
      prop: "opStartTime",
      label: "执行开始时间",
      fixed: false,
      type: "text"
    }, {
      prop: "opEndTime",
      label: "执行结束时间",
      fixed: false,
      type: "text"
    }, {
      prop: "applyUser",
      label: "申请人",
      fixed: false,
      type: "text"
    }, {
      prop: "applyReason",
      label: "申请事由",
      fixed: false,
      type: "text"
    }, {
      prop: "applyTime",
      label: "申请时间",
      fixed: false,
      type: "text"
    }, {
      prop: "auditUser",
      label: "审核人",
      fixed: false,
      type: "text"
    }, {
      prop: "auditUserMobile",
      label: "审核人电话",
      fixed: false,
      type: "text"
    },
    // 1-驳回申请；2-同意申请；3-撤回申请
    {
      prop: "auditState",
      label: "状态",
      formatData: formatCode,
      type: function (row) {
        if (row.auditState == 1) {
          return 'error';
        } else if (row.auditState == 2) {
          return 'success';
        } else if (row.auditState == 3) {
          return 'warning';
        } else {
          return 'info';
        }
      }
    }, {
      prop: "operation",
      label: "操作",
      width: "200px",
      fixed: 'right',
      operation: [{
        name: '同意',
        clickFun: row => handleAudit1(row, 2),
        hasPermi: [],
        disabledHandle(row) {
          return curUserId == row.applyUserId; //审核人id和当前登录账号的id一致且待审核
        }
      }, {
        name: '驳回',
        clickFun: row => handleAudit1(row, 1),
        hasPermi: [],
        disabledHandle(row) {
          return curUserId == row.applyUserId; //审核人id和当前登录账号的id一致且待审核
        }
      }, {
        name: '撤回',
        clickFun: row => handleAudit(row),
        hasPermi: [],
        disabledHandle(row) {
          return curUserId == row.auditUserId || row.auditState != 0; ////申请人id和当前登录账号的id一致且待审核展示撤回按钮
        }
      }, {
        name: '重新申请',
        clickFun: row => handleRetry(row),
        hasPermi: [],
        disabledHandle(row) {
          return curUserId == row.auditUserId || row.auditState == 2 || row.auditState == 0; //申请人id和当前登录账号的id一致且驳回和撤回的展示重新申请按钮
        }
      }]
    }];
    const handleAudit1 = (row, type) => {
      if (type == 1) {
        state.dialogVisible = true;
        state.curId = row.id;
        return;
      }
      let params = {
        "auditComment": "",
        "auditState": type,
        "id": row.id
      };
      loading.value = true;
      updateState(params).then(res => {
        ElMessage.closeAll();
        if (res.code == 0) {
          ElMessage.success("审核成功");
          getList();
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    // 撤回
    const handleAudit = row => {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认撤回此申请?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          "auditComment": "",
          "auditState": 3,
          "id": row.id
        };
        updateState(params).then(res => {
          ElMessage.closeAll();
          if (res.code == 0) {
            ElMessage.success("撤回成功");
            getList();
          } else {
            ElMessage.error(res.msg);
          }
        }).finally(() => {});
      }).catch(function () {});
    };
    const submit = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          delete params.originDate;
          if (state.form.id) {
            updateAudit(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("申请成功");
                state.openDataScope = false;
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addAudit(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("申请成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    const applyFormRef = ref(null);
    const submitAudit = () => {
      const formEl = unref(applyFormRef);
      formEl.validate(valid => {
        if (valid) {
          loading.value = true;
          let params = {
            "auditComment": state.applyForm.auditComment,
            "auditState": 1,
            "id": state.curId
          };
          updateState(params).then(res => {
            ElMessage.closeAll();
            if (res.code == 0) {
              state.dialogVisible = false;
              ElMessage.success("驳回成功");
              getList();
            } else {
              ElMessage.error(res.msg);
            }
          }).finally(() => {
            loading.value = false;
          });
        }
      });
    };
    onMounted(async () => {});
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.open = true;
      state.form = {
        actNum: '',
        opStartTime: '',
        opEndTime: '',
        originDate: "",
        applyReason: '',
        valuePos: "",
        valueOpenPos: ""
      };
    };
    // 重新申请
    const handleRetry = row => {
      state.open = true;
      state.form = {
        ...row
      };
      state.form.originDate = [row.opStartTime, row.opEndTime];
    };
    const cancel = function () {
      state.open = false;
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-nianyue",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        tableHeaderName: "monitorAlarmRealTime",
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.open = $event),
        size: "600px",
        title: "我的申请",
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("立即申请")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "驳回原因",
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.dialogVisible = $event),
        width: "40%",
        "close-on-click-modal": false,
        "before-close": _ctx.closeApply
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = $event => submitAudit()),
          loading: _ctx.applyLoading
        }, {
          default: _withCtx(() => [_createTextVNode("驳回")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: _ctx.closeApply
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "applyFormRef",
          ref: applyFormRef,
          model: state.applyForm,
          rules: state.applyRules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "驳回原因",
            prop: "auditComment"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.applyForm.auditComment,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.applyForm.auditComment = $event),
              rows: 5,
              type: "textarea",
              placeholder: "请输入驳回原因"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "before-close"])]);
    };
  }
});